import aboutImage from "../assets/About_US.png";
import contactImage from "../assets/Contact_US.png";
import heroPoster from "../assets/Landing_page.gif";
import logoImage from "../assets/Thamizhi_logo.png";
import whyChooseImage from "../assets/Why_Choose_US.png";
import arecaImage from "../assets/products/areca.jpg";
import bagasseImage from "../assets/products/begasse.jpg";
import marketImage from "../assets/products/market.jpg";

export const siteUrl = "https://thamizhiofficial.com";

export const defaultKeywords = [
  "Thamizhi International Ventures",
  "export company India",
  "import export company Tamil Nadu",
  "bagasse products exporter",
  "areca leaf products exporter",
  "eco-friendly tableware supplier",
  "sustainable packaging export",
  "global sourcing India",
];

export const companyInfo = {
  name: "Thamizhi International Ventures",
  shortName: "Thamizhi",
  tagline: "Premium Indian sourcing for international buyers.",
  heroTagline: "Eco-conscious exports, executed with precision and clarity.",
  description:
    "Thamizhi International Ventures is an export and import company from Tamil Nadu, India, helping international buyers source eco-friendly tableware, packaging, and market-led product lines with dependable execution.",
  location: "Sathyamangalam, Tamil Nadu, India",
  email: "contact@thamizhiofficial.com",
  primaryPhone: "+91 93457 00533",
  secondaryPhone: "+91 94459 84937",
  phoneHref: "tel:+919345700533",
  secondaryPhoneHref: "tel:+919445984937",
  whatsappNumber: "919345700533",
  whatsappMessage:
    "Hello Thamizhi International Ventures, I would like to discuss export products and sourcing.",
  addressLines: [
    "Do.No.5/1135, M.G.R Nagar, Malayadipudur Road,",
    "Sathyamangalam, Erode - 638402",
    "Tamil Nadu, India",
  ],
  socialLinks: [
    {
      label: "Facebook",
      href: "https://www.facebook.com/621698077703975",
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/thamizhi_offical/",
    },
    {
      label: "X",
      href: "https://x.com/Thamizhi_Off",
    },
    {
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/thamizhi-international-ventures/",
    },
  ],
  logo: logoImage,
  heroPoster,
};

export const navigationLinks = [
  { label: "Home", to: "/", matchPaths: ["/"] },
  { label: "About", to: "/about", matchPaths: ["/about", "/aboutus"] },
  { label: "Services", to: "/services", matchPaths: ["/services"] },
  { label: "Products", to: "/products", matchPaths: ["/products"] },
  {
    label: "Why Choose Us",
    to: "/why-choose-us",
    matchPaths: ["/why-choose-us", "/whychooseus"],
  },
  { label: "Contact", to: "/contact", matchPaths: ["/contact"] },
];

export const productFamilies = [
  {
    title: "Areca Leaf Tableware",
    description:
      "Naturally fallen areca palm leaf plates, bowls, and serving pieces with a clean finish for hospitality, catering, and retail buyers.",
    image: arecaImage,
    accent: "Natural leaf-crafted dining range",
  },
  {
    title: "Bagasse Products",
    description:
      "Compostable sugarcane bagasse tableware and food packaging designed for food service, takeaway, and private label export programs.",
    image: bagasseImage,
    accent: "Premium molded fiber food packaging",
  },
  {
    title: "Market-Led Sourcing",
    description:
      "Flexible sourcing support for buyer-requested eco alternatives, packaging ideas, and emerging product opportunities shaped by demand.",
    image: marketImage,
    accent: "Responsive sourcing for evolving markets",
  },
];

export const aboutPillars = [
  {
    title: "Reliable sourcing",
    description:
      "We work around consistency, commercial clarity, and product suitability for international buyers.",
  },
  {
    title: "Export-ready execution",
    description:
      "Documentation, packaging, and shipment coordination are treated as part of the product experience, not as an afterthought.",
  },
  {
    title: "Professional communication",
    description:
      "Buyers receive structured updates, realistic lead-time planning, and a team that values long-term trade relationships.",
  },
];

export const services = [
  {
    title: "Export counselling",
    description:
      "Planning support around product fit, shipment structure, paperwork expectations, and buyer onboarding.",
  },
  {
    title: "Product sourcing",
    description:
      "Supplier discovery and range curation focused on dependable quality, commercial viability, and scalable fulfillment.",
  },
  {
    title: "Customs and documentation",
    description:
      "Structured support for export paperwork, compliance handling, certificates, and customs-facing requirements.",
  },
  {
    title: "Logistics coordination",
    description:
      "Shipment planning with packaging, handoff timing, and dispatch visibility built around smooth delivery execution.",
  },
  {
    title: "Quality reviews",
    description:
      "Product-level checks and shipment readiness reviews to protect buyer expectations before dispatch.",
  },
  {
    title: "Market research",
    description:
      "Practical demand and category insights to help buyers and distributors make sharper sourcing decisions.",
  },
  {
    title: "Packaging solutions",
    description:
      "Export-friendly packaging recommendations balancing presentation, protection, and warehouse efficiency.",
  },
];

export const whyChooseReasons = [
  {
    title: "Buyer-first planning",
    description:
      "Every project is approached from the buyer's commercial need, not from a one-size-fits-all catalog pitch.",
  },
  {
    title: "Clear documentation flow",
    description:
      "We value accurate paperwork and straightforward shipment communication to reduce uncertainty across the trade cycle.",
  },
  {
    title: "Eco-focused assortment",
    description:
      "Our product direction stays aligned with the rising demand for sustainable tableware and packaging.",
  },
  {
    title: "Packaging discipline",
    description:
      "Products are prepared with export movement, stacking, and transit handling in mind.",
  },
  {
    title: "Responsive coordination",
    description:
      "You get timely responses, realistic planning, and a team that stays available through shipment milestones.",
  },
  {
    title: "Long-term trade mindset",
    description:
      "We aim to become a dependable sourcing partner for repeat orders, new product lines, and evolving market needs.",
  },
  {
    title: "Quality-led selection",
    description:
      "Ranges are curated with practicality, finish quality, and buyer presentation standards in mind.",
  },
  {
    title: "Flexible product development",
    description:
      "We can support category expansion and buyer-specific assortments as market opportunities change.",
  },
];

export const workflowSteps = [
  {
    title: "Understand buyer requirements",
    description:
      "We align on product expectations, commercial priorities, documentation needs, and destination market context.",
  },
  {
    title: "Curate and confirm the range",
    description:
      "Products are shortlisted with packaging, sizing, category fit, and shipment readiness in view.",
  },
  {
    title: "Prepare shipment execution",
    description:
      "Documentation, packing, and logistics coordination move forward through a structured dispatch workflow.",
  },
  {
    title: "Support the relationship",
    description:
      "We stay engaged beyond dispatch with responsive communication for repeat orders and future categories.",
  },
];

export const exportMarkets = [
  {
    name: "United Arab Emirates",
    detail: "Retail, catering, and hospitality buyers",
  },
  {
    name: "Saudi Arabia",
    detail: "Food service and distribution programs",
  },
  {
    name: "Qatar",
    detail: "Takeaway packaging and premium event supply",
  },
  {
    name: "Singapore",
    detail: "Sustainability-led food and retail demand",
  },
  {
    name: "Malaysia",
    detail: "Importer and wholesale eco product channels",
  },
  {
    name: "Sri Lanka",
    detail: "Regional trade and hospitality support",
  },
  {
    name: "United Kingdom",
    detail: "Private label and sustainable category buyers",
  },
  {
    name: "Germany",
    detail: "Compostable packaging and eco retail focus",
  },
];

export const buyerPromises = [
  "Professional communication from inquiry to shipment",
  "Eco-focused product curation with commercial clarity",
  "Export documentation handled with discipline",
  "Premium presentation suitable for international buyers",
];

export const pageImages = {
  about: aboutImage,
  contact: contactImage,
  whyChoose: whyChooseImage,
  heroPoster,
};
